import React from 'react';
import { MdClose, MdBusiness, MdLocationOn, MdPerson, MdPhone, MdEmail, MdStore, MdDevices, MdVerifiedUser, MdGroup } from 'react-icons/md';

const ViewDetailsModal = ({ isOpen, onClose, data, type, title }) => {
  if (!isOpen || !data) return null;

  const renderField = (label, value, icon = null) => {
    if (!value || value === 'N/A' || value === null || value === undefined) return null;
    
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '12px 0',
        borderBottom: '1px solid #f0f0f0'
      }}>
        {icon && <div style={{ color: '#1976d2', minWidth: 20 }}>{icon}</div>}
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 12, color: '#666', fontWeight: '500', marginBottom: 4 }}>
            {label}
          </div>
          <div style={{ fontSize: 14, color: '#333', fontWeight: '600' }}>
            {value}
          </div>
        </div>
      </div>
    );
  };

  const renderStatusBadge = (status) => {
    const getStatusColor = (status) => {
      switch (status?.toLowerCase()) {
        case 'active':
          return { bg: '#e8f5e8', color: '#2e7d32' };
        case 'inactive':
          return { bg: '#ffebee', color: '#c62828' };
        case 'suspended':
          return { bg: '#fff3cd', color: '#856404' };
        case 'maintenance':
          return { bg: '#fff3cd', color: '#856404' };
        default:
          return { bg: '#f5f5f5', color: '#666' };
      }
    };

    const colors = getStatusColor(status);
    return (
      <span style={{
        padding: '6px 12px',
        backgroundColor: colors.bg,
        color: colors.color,
        borderRadius: '20px',
        fontSize: '12px',
        fontWeight: '600',
        textTransform: 'capitalize'
      }}>
        {status || 'Unknown'}
      </span>
    );
  };

  const renderGroupDetails = () => (
    <div style={{ padding: '20px 0' }}>
      {renderField('Group Name', data.group_name, <MdGroup size={16} />)}
      {renderField('Zone', data.zone_name, <MdLocationOn size={16} />)}
      {renderField('MMDA', data.mmda_name, <MdBusiness size={16} />)}
      {renderField('Description', data.description)}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '12px 0',
        borderBottom: '1px solid #f0f0f0'
      }}>
        <div style={{ color: '#1976d2', minWidth: 20 }}>
          <MdVerifiedUser size={16} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 12, color: '#666', fontWeight: '500', marginBottom: 4 }}>
            Status
          </div>
          <div>{renderStatusBadge(data.status)}</div>
        </div>
      </div>
    </div>
  );

  const renderMmdaDetails = () => (
    <div style={{ padding: '20px 0' }}>
      {renderField('MMDA Name', data.name, <MdBusiness size={16} />)}
      {renderField('Region', data.region, <MdLocationOn size={16} />)}
      {renderField('District Code', data.district_code)}
      {renderField('Created Date', data.created_at ? new Date(data.created_at).toLocaleDateString() : null)}
    </div>
  );

  const renderTraderDetails = () => (
    <div style={{ padding: '20px 0' }}>
      {renderField('Business Name', data.business_name, <MdStore size={16} />)}
      {renderField('Owner Name', data.owner_name, <MdPerson size={16} />)}
      {renderField('First Name', data.first_name, <MdPerson size={16} />)}
      {renderField('Middle Name', data.middle_name)}
      {renderField('Last Name', data.last_name)}
      {renderField('Phone', data.phone, <MdPhone size={16} />)}
      {renderField('Email', data.email, <MdEmail size={16} />)}
      {renderField('Business Type', data.business_type)}
      {renderField('Location', data.location, <MdLocationOn size={16} />)}
      {renderField('MMDA', data.mmda_name, <MdBusiness size={16} />)}
      {renderField('Zone', data.zone_name, <MdLocationOn size={16} />)}
      {renderField('Group', data.group_name, <MdGroup size={16} />)}
      {renderField('National ID Type', data.national_id_type_name)}
      {renderField('National Info', data.national_info)}
      {renderField('Registration Date', data.registration_date ? new Date(data.registration_date).toLocaleDateString() : null)}
      {renderField('Created By', data.created_by_name, <MdPerson size={16} />)}
      {renderField('Created At', data.created_at ? new Date(data.created_at).toLocaleDateString() : null)}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '12px 0',
        borderBottom: '1px solid #f0f0f0'
      }}>
        <div style={{ color: '#1976d2', minWidth: 20 }}>
          <MdVerifiedUser size={16} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 12, color: '#666', fontWeight: '500', marginBottom: 4 }}>
            Status
          </div>
          <div>{renderStatusBadge(data.status)}</div>
        </div>
      </div>
    </div>
  );

  const renderRevenueOfficerDetails = () => (
    <div style={{ padding: '20px 0' }}>
      {renderField('First Name', data.first_name, <MdPerson size={16} />)}
      {renderField('Middle Name', data.middle_name)}
      {renderField('Last Name', data.last_name)}
      {renderField('Phone', data.phone, <MdPhone size={16} />)}
      {renderField('Email', data.email, <MdEmail size={16} />)}
      {renderField('MMDA', data.mmda_name, <MdBusiness size={16} />)}
      {renderField('Zone', data.zone_name, <MdLocationOn size={16} />)}
      {renderField('Created By', data.created_by_name, <MdPerson size={16} />)}
      {renderField('Created At', data.created_at ? new Date(data.created_at).toLocaleDateString() : null)}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '12px 0',
        borderBottom: '1px solid #f0f0f0'
      }}>
        <div style={{ color: '#1976d2', minWidth: 20 }}>
          <MdVerifiedUser size={16} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 12, color: '#666', fontWeight: '500', marginBottom: 4 }}>
            Status
          </div>
          <div>{renderStatusBadge(data.status)}</div>
        </div>
      </div>
    </div>
  );

  const renderDeviceDetails = () => (
    <div style={{ padding: '20px 0' }}>
      {renderField('Serial Number', data.serial_number || data.device_serial, <MdDevices size={16} />)}
      {renderField('Assigned User', data.assigned_user_name, <MdPerson size={16} />)}
      {renderField('MMDA', data.mmda_name, <MdBusiness size={16} />)}
      {renderField('Last Sync', data.last_sync_at ? new Date(data.last_sync_at).toLocaleDateString() : null)}
      {renderField('Created At', data.created_at ? new Date(data.created_at).toLocaleDateString() : null)}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '12px 0',
        borderBottom: '1px solid #f0f0f0'
      }}>
        <div style={{ color: '#1976d2', minWidth: 20 }}>
          <MdVerifiedUser size={16} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 12, color: '#666', fontWeight: '500', marginBottom: 4 }}>
            Status
          </div>
          <div>{renderStatusBadge(data.status)}</div>
        </div>
      </div>
    </div>
  );

  const renderZoneDetails = () => (
    <div style={{ padding: '20px 0' }}>
      {renderField('Zone Name', data.zone_name, <MdLocationOn size={16} />)}
      {renderField('MMDA', data.mmda_name, <MdBusiness size={16} />)}
      {renderField('Description', data.description)}
      {renderField('Created At', data.created_at ? new Date(data.created_at).toLocaleDateString() : null)}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '12px 0',
        borderBottom: '1px solid #f0f0f0'
      }}>
        <div style={{ color: '#1976d2', minWidth: 20 }}>
          <MdVerifiedUser size={16} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 12, color: '#666', fontWeight: '500', marginBottom: 4 }}>
            Status
          </div>
          <div>{renderStatusBadge(data.status)}</div>
        </div>
      </div>
    </div>
  );

  const renderContent = () => {
    switch (type) {
      case 'group':
        return renderGroupDetails();
      case 'mmda':
        return renderMmdaDetails();
      case 'trader':
        return renderTraderDetails();
      case 'revenue-officer':
        return renderRevenueOfficerDetails();
      case 'device':
        return renderDeviceDetails();
      case 'zone':
        return renderZoneDetails();
      default:
        return <div>No details available</div>;
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: 20
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: 12,
        maxWidth: 600,
        width: '100%',
        maxHeight: '80vh',
        overflow: 'hidden',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)'
      }}>
        {/* Header */}
        <div style={{
          padding: '20px 24px',
          borderBottom: '1px solid #f0f0f0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: '#f8f9fa'
        }}>
          <h3 style={{
            margin: 0,
            fontSize: 18,
            fontWeight: '600',
            color: '#333'
          }}>
            {title || 'View Details'}
          </h3>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 8,
              borderRadius: 6,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#666',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = '#e9ecef';
              e.currentTarget.style.color = '#333';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#666';
            }}
          >
            <MdClose size={20} />
          </button>
        </div>

        {/* Content */}
        <div style={{
          padding: '0 24px',
          maxHeight: 'calc(80vh - 80px)',
          overflowY: 'auto'
        }}>
          {renderContent()}
        </div>

        {/* Footer */}
        <div style={{
          padding: '16px 24px',
          borderTop: '1px solid #f0f0f0',
          backgroundColor: '#f8f9fa',
          display: 'flex',
          justifyContent: 'flex-end'
        }}>
          <button
            onClick={onClose}
            style={{
              padding: '8px 16px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: 6,
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: '500',
              transition: 'background-color 0.2s ease'
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#5a6268'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = '#6c757d'}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewDetailsModal;
